import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0052',
    ecrans: ['00-2']
});
